import api from "actions/api";
import doRequest from "actions/doRequest";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
const cardsOnPage = 8;
const intervalTime = 5000;

export const usePagination = ({ pushNotify, logout, filters, setIsFilterActive, range, isFirstLoading, intl }) => {
    
    const [routesList, setRoutesList] = useState([]);
    const [timeStatistic, setTimeStatistic] = useState([]);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [loading] = useState(false);
    const [controlPointsConfigTable, setControlPointsConfigTable] = useState([]);

    const interval = useRef(null);
  
    const loadRoutesListFromPage = useCallback((page = 1) => {
      // setLoading(true);
      const offset = cardsOnPage * (page - 1),
      count = cardsOnPage;
        const req = doRequest(api.conrolPoints.list({offset, count, filDateFrom: range.start, filDateTo: range.end, ...filters}), pushNotify, logout)
  
        req.ready.then(({ departuresDataList, timeStatistic, count, pointsConfig }) => {
            const pages = Math.ceil(count / cardsOnPage)
            if (page > pages & pages > 0) {
              loadRoutesListFromPage(pages)
            } else {
                if(isFirstLoading.current){
                  const tableConfig = calcTableCongif({pointsConfig, intl})
                  isFirstLoading.current = false;
                  setControlPointsConfigTable(tableConfig)
                }
                setTimeStatistic(timeStatistic)
                setRoutesList(departuresDataList)
                setPageCount(pages)
                setPage(page)
            }
        }).catch(console.error)
            .finally(() => {
                const filteredFilterValues = Object.values(filters).filter(el => el !== '' && el.length !== 0)
                filteredFilterValues.length !== 0 ? setIsFilterActive(true) : setIsFilterActive(false)
            })
    },[filters, intl, isFirstLoading, logout, pushNotify, range.end, range.start, setIsFilterActive])
    
    useEffect(() => {
      if(interval.current){
        clearInterval(interval.current);
        loadRoutesListFromPage(page);
        interval.current = setInterval(()=>{
          loadRoutesListFromPage(page);
        }, intervalTime)
        return () => clearInterval(interval.current)
      }
    }, [range, filters, page, pageCount, loadRoutesListFromPage]);

    useEffect(() => {
      loadRoutesListFromPage(page);
      if(!interval.current){
        interval.current = setInterval(() => {
        loadRoutesListFromPage(page);
        }, intervalTime);
        return () => clearInterval(interval.current)
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [routesList, controlPointsConfigTable, timeStatistic, page, pageCount, loadRoutesListFromPage, loading];
  };

  const calcTableCongif = ({pointsConfig, intl}) => {
    if(pointsConfig.length === 0) {return pointsConfig}
    const readyConfig = pointsConfig.map((point, index)=>({id: index, pointsName:[point], headerTranslatePath: intl.formatMessage({id: `controlPoint.${point}`})}))
    readyConfig[readyConfig.length-1].hideSpentTime = true;
    return readyConfig;
   }
  
  export const useControlPointsFilterList = ({options, intl}) => {
    return useMemo(
      () => {
        return [
          {
            title: intl.formatMessage({ id: "title.car" }),
            type: "inputText",
            name: "filCarNumber",
          },
        ];
      },
      [intl],
    ); // eslint-disable-line react-hooks/exhaustive-deps
  }